import React from 'react';
import { Alert, Box, Chip, Typography } from '@mui/material';
import useLocatorsSearch from './useLocatorsSearch';
import useEditLocator from './useEditLocator';
import useCloneLocator from './useCloneLocator';
import useCreateLocator from './useCreateLocator';
import LocatorsFilters from './LocatorsFilters';
import LocatorsTable from './LocatorsTable';
import EditLocatorModal from './EditLocatorModal';
import CloneLocatorModal from './CloneLocatorModal';
import CreateLocatorModal from './CreateLocatorModal';

export default function LocatorsPage() {
  const search = useLocatorsSearch();
  const edit = useEditLocator(search.refetch);
  const clone = useCloneLocator(search.refetch);
  const create = useCreateLocator(search.refetch);

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Typography variant="h5" fontWeight="bold">
          Locator Management
        </Typography>
        <Chip label="DEV" size="small" color="warning" sx={{ fontSize: 10, height: 18 }} />
      </Box>

      <LocatorsFilters
        form={search.form}
        pages={create.pages}
        loading={search.loading}
        resultCount={Array.isArray(search.rows) ? search.rows.length : 0}
        onClear={search.handleClear}
        onFilterChange={() => search.setPageNumber(0)}
        onOpenCreate={create.handleOpen}
      />

      {search.error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={search.clearMessages}>
          {search.error}
        </Alert>
      )}
      {edit.error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={edit.clearMessages}>
          {edit.error}
        </Alert>
      )}
      {edit.successMsg && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={edit.clearMessages}>
          {edit.successMsg}
        </Alert>
      )}
      {clone.error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={clone.clearMessages}>
          {clone.error}
        </Alert>
      )}
      {clone.successMsg && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={clone.clearMessages}>
          {clone.successMsg}
        </Alert>
      )}
      {create.error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={create.clearMessages}>
          {create.error}
        </Alert>
      )}
      {create.successMsg && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={create.clearMessages}>
          {create.successMsg}
        </Alert>
      )}

      <LocatorsTable
        rows={search.rows}
        onEdit={edit.handleOpen}
        onClone={clone.handleOpen}
        page={search.pageNumber}
        rowsPerPage={search.rowsPerPage}
        total={search.total}
        onPageChange={(e, newPage) => search.setPageNumber(newPage)}
        onRowsPerPageChange={(e) => {
          search.setRowsPerPage(parseInt(e.target.value, 10));
          search.setPageNumber(0);
        }}
        sortBy={search.sortBy}
        sortOrder={search.sortOrder}
        onRequestSort={(event, property) => {
          const isAsc = search.sortBy === property && search.sortOrder === 'asc';
          search.setSortOrder(isAsc ? 'desc' : 'asc');
          search.setSortBy(property);
        }}
      />

      <EditLocatorModal
        row={edit.row}
        form={edit.form}
        loading={edit.loading}
        error={edit.error}
        onClose={edit.handleClose}
        onSave={edit.handleSave}
      />

      <CloneLocatorModal
        row={clone.row}
        form={clone.form}
        loading={clone.loading}
        error={clone.error}
        onClose={clone.handleClose}
        onSave={clone.handleSave}
      />

      <CreateLocatorModal
        open={create.open}
        form={create.form}
        pages={create.pages}
        markets={create.markets}
        loading={create.loading}
        error={create.error}
        onClose={create.handleClose}
        onSave={create.handleSave}
      />
    </Box>
  );
}
